import type Checkpoint from '../model/Checkpoint'

export function nextUnseenCheckpointVideo(
  checkpoints: Checkpoint[],
  gatedCheckpointIds: ReadonlySet<string>,
  teamProgress: number,
  seenCheckpointIds: ReadonlySet<string>,
  goal: number,
  finishLineVideoUrl?: string,
): Checkpoint | undefined {
  return [...checkpoints]
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .find((checkpoint) => {
      if (teamProgress < checkpoint.threshold) return false
      if (!checkpoint.videoUrl) return false
      if (gatedCheckpointIds.has(checkpoint.id)) return false
      if (finishLineVideoUrl && checkpoint.threshold >= goal) return false
      if (seenCheckpointIds.has(checkpoint.id)) return false
      return true
    })
}
